<template>
    <div class="mainDiv">
      <el-row>

        <el-col style="" :span="8">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">出票总金额</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countCreateMoney}}</b>
                  </span>
                </h1>
                <span>元</span>
              </div>
              
            </div>
          </div>
        </el-col>

        <el-col style="" :span="8">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">出票总人数</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countPersonNum}}</b>
                  </span>
                </h1>
                <span>人</span>
              </div>
              
            </div>
          </div>
        </el-col>
        <el-col style="" :span="8">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">出票总张数</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countCreateNum}}</b>
                  </span>
                </h1>
                <span>张</span>
              </div>
              
            </div>
          </div>
        </el-col>

      </el-row>

    <el-form  ref="queryCondition" :model="queryCondition">
      <el-row >
        <el-col :span="5">
          出票人员
          <el-select size="mini" v-model="queryCondition.userId" clearable placeholder="请选择" class="dialogDataWidth"  style="width: 60%;">
              <el-option v-for="item in userSelectedIdList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
        </el-col>
        <el-col :span="5">
          票种
          <el-select size="mini" v-model="queryCondition.ticketType" clearable placeholder="请选择" class="dialogDataWidth"  style="width: 60%;">
              <el-option v-for="item in type_option" :key="item.code" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
        </el-col>
        <el-col :span="10">出票日期
            <el-date-picker size="mini" v-model="queryCondition.createDate" type="daterange" clearable style="width: 80%;"
                            align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" >
            </el-date-picker>
        </el-col>
        <!-- <el-col :span="5">
          开始时间
          <el-input size="mini" v-model="queryCondition.roleName" clearable placeholder="请输入内容" class="dialogDataWidth" style="width: 60%;"></el-input>
        </el-col>
        <el-col :span="5">
          结束时间
          <el-input size="mini" v-model="queryCondition.roleName" clearable placeholder="请输入内容" class="dialogDataWidth" style="width: 60%;"></el-input>
        </el-col> -->
        <el-col :span="4" >
          <el-button type="primary" size="mini" @click='query(1)' icon="el-icon-search">查询</el-button>
          <el-button type="primary" plain size="mini" @click="reset" icon="el-icon-refresh">重置</el-button>
        </el-col>
      </el-row>

    </el-form>

    <el-table class="el-table" stripe size="mini" :data="pagedata.content" align="center" style="margin-top: 10px;" header-row-class-name="tableHeader">
      <el-table-column align='center' prop="id" type="index" label="序号"  label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="ticket_sn" label="票号" label-class-name="greenLabel" width="300"></el-table-column>
      <el-table-column align='center' prop="createTime" label="出票时间" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="user_name" label="操作人" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="ticket_type" label="票种" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="ticket_from" label="购票渠道" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="pay_type" label="支付方式" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="person_num" label="可用人数" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="total_price" label="票价(元)"  label-class-name="greenLabel"></el-table-column>
      
    </el-table>

      <el-pagination
        :page-size="pagedata.size"
        layout="total, prev, pager, next, jumper"
        :total="pagedata.totalElements"
        :current-page.sync="pagedata.number"
        @current-change="query" class="mb">
      </el-pagination>

    </div>
</template>
<script>

  export default {
    name: 'chaekList',
    mounted: function () {
      this.selectUser();
      this.type_option = this.CommonUtil.getCodeList('ticket_type');
      this.queryCondition.createDate = [this.DateUtil.getCurrentDate(), this.DateUtil.getCurrentDate()];
      this.query();
    },
    data() {
      return {
        msg: 'this is role',
        countCreateMoney: 0,
        countCreateNum: 0,
        countPersonNum: 0,
        userSelectedIdList: [],
        queryCondition: {
          createDate: [],
          userId: '',
          ticketType: ''
        },
        pagedata: {
          content: [],
          totalElements: 0,
          totalPages: 1,
          size: 10,
          number: 1,
        },
        type_option: [],
      }
    },
    methods: {
      //状态改成汉字
      formatStr(row, column) {
        if(column.property == 'ticket_type'){
          return this.CommonUtil.getCodeValue('ticket_type', row.ticket_type);
        }else if(column.property == 'pay_type'){
          return this.CommonUtil.getCodeValue('pay_type', row.pay_type);
        }else{
          return this.CommonUtil.getCodeValue('ticket_from', row.ticket_from);
        }
      },
      
      // 查询按钮
      query: function (currentPage) {
        if(!isNaN(currentPage) && currentPage > 0){
          this.pagedata.number = currentPage;
        }

        var url = '/ticket/createTicket';
        url += '?userId=' + this.queryCondition.userId;
        if(this.queryCondition.createDate != "" && this.queryCondition.createDate != null && this.queryCondition.createDate.length == 2){
          url += "&startDate=" + this.queryCondition.createDate[0];
          url += "&endDate=" + this.queryCondition.createDate[1];
        }
        
        url += '&ticketType=' + this.queryCondition.ticketType;
        url += '&pageNumber=' + this.pagedata.number  + '&pageSize=' + this.pagedata.size;
        this.$axios.get(url).then(response => {
          if (response.data !== null && response.data !== '' && response.data !== undefined) {
            this.pagedata = response.data.page;
            this.countCreateMoney = response.data.countCreateMoney[0].num;
            this.countCreateNum = response.data.countCreateNum[0].num;
            this.countPersonNum = response.data.countPersonNum[0].num;
          }
        })
      },
      reset: function () {
        this.queryCondition.createDate = [];
        this.queryCondition.userId = '';
        this.queryCondition.ticketType = '';
        this.$refs.queryCondition.resetFields();
        this.query(1);
      },
      
      /**
       * 给角色选人
       */
      selectUser(){
        this.$axios.get('/user/getUserListByRole/3').then(response => {
          this.userSelectedIdList = response.data;
        })
      },
      
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/check/ticket.vue